import { connect } from 'react-redux';
import HeaderButtons from './HeaderButtons';
import { getFilterIdentifierCount } from '../../../filters/store/filtersSlice';

const mapState = state => ({
  activeSelfAuthTab: state.loadingManagement.selfAuthorizations.activeSelfAuthTab,
  filterIdentifierCount: getFilterIdentifierCount(state),
  selfAuthorizations: state.loadingManagement.selfAuthorizations.selfAuthorizations,
});

export default connect(mapState)(HeaderButtons);
